import { useQuery } from "@tanstack/react-query";

import { pendingActionsQueryOptions } from "@/domains/profile/factories/pending-actions-query-options";

export const usePendingActions = () => {
  return useQuery({
    ...pendingActionsQueryOptions.all,
  });
};
